var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    d: "M0 0h167v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M345 0h167v512H345z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFr);
export default __webpack_public_path__ + "static/media/fr.2c0a89ad94ffc965629204acd177d7da.svg";
export { ForwardRef as ReactComponent };